// extracted by mini-css-extract-plugin
export var backgroundContainmentImage = "HeroSectionChampionship-module--backgroundContainmentImage--40f8b";
export var backgroundImage = "HeroSectionChampionship-module--backgroundImage--fbae7";
export var championshipLogo = "HeroSectionChampionship-module--championshipLogo--85c25";
export var content = "HeroSectionChampionship-module--content--0f831";
export var credits = "HeroSectionChampionship-module--credits--0c873";
export var heading = "HeroSectionChampionship-module--heading--8c0c9";
export var intro = "HeroSectionChampionship-module--intro--191af";
export var logo = "HeroSectionChampionship-module--logo--58187";
export var naming = "HeroSectionChampionship-module--naming--6690a";
export var register = "HeroSectionChampionship-module--register--6a189";
export var subtitle = "HeroSectionChampionship-module--subtitle--bc550";
export var title = "HeroSectionChampionship-module--title--a8edc";
export var wrapper = "HeroSectionChampionship-module--wrapper--262a3";
export var year = "HeroSectionChampionship-module--year--14ff7";